export const IconPreviewPage =
  'flex flex-col items-center justify-start w-[100vw] min-h-screen h-screen overflow-y-auto bg-slate-50 text-slate-900 px-6 py-10';

export const IconPreviewTopBar = 'flex w-full max-w-4xl justify-end mb-6';

export const IconPreviewHeader =
  'max-w-4xl mx-auto text-center space-y-3 mb-12';

export const IconPreviewTitle = 'text-3xl font-semibold tracking-tight';

export const IconPreviewStats =
  'inline-flex items-center justify-center gap-2 text-sm font-medium text-slate-500';

export const IconPreviewContainer = 'space-y-8 max-w-6xl mx-auto';

export const IconGroupSection =
  'bg-white rounded-2xl border border-slate-200 shadow-[0_20px_60px_rgba(15,23,42,0.04)]';

export const IconGroupHeader =
  'flex items-center justify-between px-6 py-4 border-b border-slate-100';

export const IconGroupTitle = 'text-lg font-semibold text-slate-900';

export const IconGroupBadge =
  'inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full bg-slate-100 text-slate-600';

export const IconGrid =
  'flex flex-wrap gap-8 p-6 justify-center items-center';

export const IconCard =
  'flex flex-col items-center gap-3 cursor-pointer transition-all duration-200 hover:scale-105 hover:opacity-80 active:scale-95';

export const IconLabel =
  'text-xs font-medium text-slate-700 break-all leading-tight text-center max-w-full';

export const IconSizeLabel =
  'text-xs font-normal text-slate-500 leading-tight text-center max-w-full';

export const IconPreviewHomeButton =
  'inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:-hover:border-indigo-200 hover:text-indigo-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-200';

export const SimpleToastContainer =
  'flex items-center justify-between gap-3 bg-blue-gray-900 border border-slate-300 rounded-8px px-3 py-2 text-sm text-white shadow-sm';

export const SimpleToastText = 'flex-1';

export const SimpleToastCloseButton =
  'flex items-center justify-center cursor-pointer p-1 hover:opacity-70 transition-opacity relative z-10 pointer-events-auto';
